import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Main from './Main';
import MainConvertedFull from './MainConvertedFull';
import { Posting, ReservedTag, CardBanner, ReportMessage, Alert } from './styles';
import { PostingsOperations } from '../../../../ducks/posting';

const siteId = process.env.REACT_APP_BUILD_SITE;

function PostingCard({ posting, onClick, openDetailPosting, isParticular }) {
  const { t } = useTranslation();
  const {
    stateAndDates,
    isReservado,
    postingId,
    quality,
    loadingQuality,
    loadingPerformanceStatus,
    performanceStatusError,
    performanceStatus,
    qualityError,
    loadingLeads,
    loadingReports,
    postingReports,
    reportsError,
    loadingLogs,
    logsError,
    postingLogs,
    isTargetI24Full,
    postingFull
  } = posting;
  const dispatch = useDispatch();
  const { status } = stateAndDates[0] || [''];
  const {
    fetchQuality,
    fetchPerformanceStatus,
    fetchReports,
    getPostingViewsStats,
    getPostingLogs
  } = PostingsOperations;
  const isDraft = status === 'DRAFT';
  const totalReport = postingReports && postingReports.totalReport;
  const callPerformance = siteId !== 'VAMX';

  useEffect(() => {
    if (!loadingQuality && !quality && quality !== 0 && !qualityError && callPerformance) {
      dispatch(fetchQuality(postingId));
    }
    if (
      !loadingPerformanceStatus &&
      !performanceStatus &&
      ![null, ''].includes(performanceStatus) &&
      !performanceStatusError &&
      !isDraft &&
      callPerformance
    ) {
      dispatch(fetchPerformanceStatus(postingId));
    }
    if (!loadingReports && !reportsError && !postingReports && !isDraft) {
      dispatch(fetchReports(postingId));
    }
    if (!loadingLogs && !logsError && !postingLogs && !isDraft) {
      dispatch(getPostingLogs(postingId));
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [loadingLeads, loadingQuality, loadingPerformanceStatus, loadingLogs, logsError]);

  useEffect(() => {
    dispatch(getPostingViewsStats(postingId));
  }, []);

  const processReports = () => {
    if (!postingReports) return;
    const { reports } = postingReports;
    let countNew = 0;
    let countChecked = 0;
    if (!reports) return;
    reports.forEach(rep => {
      countChecked += rep.checked;
      countNew += rep.unChecked;
    });
    // eslint-disable-next-line consistent-return
    return { countNew, countChecked };
  };

  const processedReportCounts = processReports();
  const isPostingConvertedFull =
    postingFull && (postingFull.statusPostingFull === 'ONLINE' || postingFull.statusPostingFull === 'OFFLINE');

  return (
    <>
      <Posting
        onClick={onClick}
        isAvailableToConvertToFull={isTargetI24Full && !isPostingConvertedFull}
        isPostingConvertedFull={isPostingConvertedFull}
      >
        {isReservado && <ReservedTag data-panel='posting-tagReservado'>Reservado</ReservedTag>}
        {isPostingConvertedFull ? (
          <MainConvertedFull posting={posting} status={status} openDetailPosting={openDetailPosting} />
        ) : (
          <Main
            isDraft={isDraft}
            posting={posting}
            status={status}
            openDetailPosting={openDetailPosting}
            isParticular={isParticular}
          />
        )}
      </Posting>
      {totalReport > 0 && (
        <CardBanner hasUncheckedReport={processedReportCounts.countNew}>
          <Alert hasUncheckedReport={processedReportCounts.countNew} />
          <ReportMessage hasUncheckedReport={processedReportCounts.countNew}>
            {!processedReportCounts.countNew ? (
              <div>
                {t('panel.avisos.report.message')} {<b>{processedReportCounts.countChecked}</b>}{' '}
                {t(`panel.avisos.report.message.end${processedReportCounts.countChecked > 1 ? '.plural' : ''}`)}
              </div>
            ) : (
              <div>
                {t('panel.avisos.report.new.message')}{' '}
                {
                  <b>
                    {processedReportCounts.countNew}{' '}
                    {t(`panel.avisos.report.new.message.end${processedReportCounts.countNew > 1 ? '.plural' : ''}`)}
                  </b>
                }
              </div>
            )}
          </ReportMessage>
        </CardBanner>
      )}
    </>
  );
}

export default React.memo(PostingCard);
